import { cx } from '@linaria/core';
import { CrossIcon, PartialCheckmarkIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { hasOpgavekompleksetTaskInputs, canValidateOpgavekompleksetTask } from '@utils/component-framework';
import { useTaskContext } from '../../components/organism.task/context.js';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../state/hook.entry.js';
import { shouldShowReport } from '../../state/util.should-show-report.js';
import { indicator, wrapper, bulletIcon } from './atom.indicator.style.js';
import { jsx } from 'react/jsx-runtime';

function StatusIndicator(props) {
  const context = useTaskContext();
  const component = useOpgavekompleksetComponent();
  const taskEntry = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[props.task.id]
  });
  const stats = taskEntry?.stats;
  const isSkipped = taskEntry?.state.skipped ?? true;
  const showResult = context !== "input" && shouldShowReport(component.data.settings.flowType);
  const hasInputs = hasOpgavekompleksetTaskInputs(props.task);
  const canValidate = canValidateOpgavekompleksetTask(props.task);
  const state = (() => {
    if (isSkipped) {
      return;
    }
    if (!showResult || !canValidate || !hasInputs) {
      return "answered";
    }
    if (!stats?.total) {
      return;
    }
    switch (true) {
      case stats.correct === stats.total:
        return "correct";
      case stats.correct > 0:
        return "partial";
      default:
        return "incorrect";
    }
  })();
  const icon = (() => {
    switch (state) {
      case "answered":
        return /*#__PURE__*/jsx("span", {
          className: bulletIcon
        });
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {});
      case "partial":
        return /*#__PURE__*/jsx(PartialCheckmarkIcon, {
          style: {
            marginTop: "0.5px",
            marginLeft: "0.5px"
          }
        });
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1.5,
          height: 10
        });
    }
  })();
  const label = (() => {
    switch (state) {
      case "answered":
        return "Besvaret";
      case "correct":
        return "Besvaret korrekt";
      case "partial":
        return "Besvaret delvist korrekt";
      case "incorrect":
        return "Besvaret forket";
      default:
        return "Ikke besvaret";
    }
  })();
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper, props.className),
    "aria-label": label,
    children: /*#__PURE__*/jsx("span", {
      className: indicator,
      "data-state": state,
      "data-validation": shouldShowReport(component.data.settings.flowType),
      children: icon
    })
  });
}

export { StatusIndicator };
//# sourceMappingURL=atom.indicator.js.map
